import { render, staticRenderFns } from "./AspectPrioriteit.vue?vue&type=template&id=7f45aa64"
import script from "./AspectPrioriteit.vue?vue&type=script&lang=js"
export * from "./AspectPrioriteit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports